var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('date-range-picker',{attrs:{"time-picker":"","always-show-calendars":true,"max-date":_vm.minEndDateCom,"show-week-numbers":false,"auto-apply":"","ranges":false,"control-container-class":"control-container"},on:{"update":_vm.update},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }